import { render } from "./ProjectDashboard.vue?vue&type=template&id=02fe2342"
import script from "./ProjectDashboard.vue?vue&type=script&lang=js"
export * from "./ProjectDashboard.vue?vue&type=script&lang=js"

import "./ProjectDashboard.vue?vue&type=style&index=0&id=02fe2342&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__